import { useMemo } from 'react';
import { buildShareUrl } from '../store/url';
import { useStore } from '../store';
import { useEditorState } from './useEditorState';

export function useShareUrl(): string {
  const state = useEditorState();
  const domainBase = useStore((s) => s.domainBase);
  const domainSub = useStore((s) => s.domainSub);
  return useMemo(
    () => buildShareUrl(state, { domainBase, domainSub }),
    [
      state.status,
      state.delay,
      state.chunks,
      state.chunkDelay,
      state.payloadParam,
      state.editorLanguage,
      state.editorContent,
      state.headers,
      domainBase,
      domainSub,
    ],
  );
}
